import { faCheck, faHourglassStart, faHourglassHalf, faHourglassEnd, faTimes } from '@fortawesome/pro-regular-svg-icons'

const def = [
	{ "value":"0%", "label":"Perso", icon:faTimes, lost:true },
	{ "value":"30%", "label":"30%", icon:faHourglassEnd },
	{ "value":"50%", "label":"50%", icon:faHourglassHalf },
	{ "value":"75%", "label":"75%", icon:faHourglassStart },
	{ "value":"100%", "label":"Accettato", icon:faCheck }
]
export default def